import type { MachineCatalogEntry } from '../machine-catalog.model';

/** Canonical mock {@link MachineCatalogEntry} (approved). */
export const MOCK_MACHINE_CATALOG_ENTRY: MachineCatalogEntry = {
  id: 1,
  name: '5-axis CNC mill',
  brand: 'DMG MORI',
  status: 'approved',
  capability_ids: [11],
  datasheets: [],
  extraction: {
    status: 'idle',
    suggested_capability_ids: [],
  },
  created_at: '2026-01-10T08:00:00Z',
};

/** Builds a {@link MachineCatalogEntry} from {@link MOCK_MACHINE_CATALOG_ENTRY}. */
export function createMockMachineCatalogEntry(
  overrides?: Partial<MachineCatalogEntry>
): MachineCatalogEntry {
  return { ...MOCK_MACHINE_CATALOG_ENTRY, ...overrides };
}

/** Builds a list of {@link MachineCatalogEntry} entries for seeding tests. */
export function createMockMachineCatalogEntryList(
  count = 3,
  overrides?: Partial<MachineCatalogEntry>
): MachineCatalogEntry[] {
  return Array.from({ length: count }, (_, i) =>
    createMockMachineCatalogEntry({
      id: i + 1,
      name: `Machine ${i + 1}`,
      ...overrides,
    })
  );
}

/** Mock pending catalog entry awaiting admin review. */
export const MOCK_MACHINE_CATALOG_PENDING: MachineCatalogEntry =
  createMockMachineCatalogEntry({
    id: 10,
    name: 'Laser cutter XL',
    brand: 'Trumpf',
    status: 'pending',
    capability_ids: [],
    submitted_by_company_id: 2,
    submitted_by_factory_id: 1,
    submitted_by_machine_park_id: 5,
    created_at: '2026-04-01T10:00:00Z',
  });

/** Mock catalog entry with completed extraction suggestions. */
export const MOCK_MACHINE_CATALOG_WITH_SUGGESTIONS: MachineCatalogEntry =
  createMockMachineCatalogEntry({
    id: 11,
    status: 'pending',
    extraction: {
      status: 'completed',
      suggested_capability_ids: [11, 12, 21],
      completed_at: '2026-01-15T10:00:00Z',
    },
  });
